"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
function getVariablesPackingMaterialPickup(move, configuration) {
    const packingMaterials = configuration.packingMaterials;
    const packmaterial = Object.fromEntries(packingMaterials.map((p, i) => [`packmaterial${i + 1}`, p.name]));
    return {
        entladestelle: util_1.getAddressVariables(move.unloadingAddresses[0]),
        ...packmaterial,
    };
}
exports.default = getVariablesPackingMaterialPickup;
//# sourceMappingURL=packingMaterialPickup.js.map